import { getRawData }              from './getRawData';
import { parseEntryValue }         from './parseEntryValue';
import { sorter }                  from './sorter';
import { searcher }                from './searcher';
import { renderByType }            from './renderByType';
import { convertToRequestFilter }  from './convertToRequestFilter';
import { convertToRequestSorting } from './convertToRequestSorting';

export type * from './table';

export const TableUtils = {
  getRawData,
  parseEntryValue,
  sorter,
  searcher,
  renderByType,
  convertToRequestFilter,
  convertToRequestSorting,
};
